// :: void => bool
export const isDev = () => process.env.REACT_APP_ENV === 'development'
